module.exports = class Url {
    static obterUrlApi() {
        const url = window.location.href
        if (url.includes('localhost') || url.includes('192.168.0.16')) {
            return "http://localhost:5000"
        }
        
        return "https://dorricoapp.com.br"
    }

    static obterGoogleMapsApiKey() {
        return "AIzaSyDFMzD5Jmsyn1Q82YhU2CbHpbTxlYFlb5Q"
    }
}